module.exports = __webpack_public_path__ + "img/2.15c40ddd.png";